// extracted by mini-css-extract-plugin
module.exports = {"link":"link-5anYV","header":"header-373B7","closeIcon":"closeIcon-2on1f","body":"body-qsRnz","buttonContainer":"buttonContainer-1C86I"};